import { Header2 } from '@cian/ui-kit';
// Tabs нет в новом ките, когда-нибудь компонент на замену
import { Tabs } from '@cian/ui-kit/prev';

import { clsx } from 'clsx';
import { FC } from 'react';

import { STICKY_HEADER_HEIGHT } from 'shared/constants/elements';

import { onNavigationLinkClick } from './internal/helpers/onNavigationLinkClick';
import { useHeaderTabsController } from './internal/hooks/useHeaderTabsController';
import { IHeaderProps } from './types';

import * as styles from './Header.css';

export const Header: FC<IHeaderProps> = props => {
  const { name, isFixed, call, callback, favorite } = props;

  const [activeTab, tabDataCollection] = useHeaderTabsController('[data-nav-tab]', 'carousel');

  return (
    <div
      className={clsx(styles['header'], { [styles['header--fixed']]: isFixed })}
      style={{ height: `${STICKY_HEADER_HEIGHT}px` }}
    >
      <div className={styles['layout']}>
        <Header2 as="div">{name}</Header2>
        <div className={styles['nav']}>
          <nav className={styles['tabs']}>
            <Tabs activeTab={activeTab} tabs={tabDataCollection.list} onChange={onNavigationLinkClick} />
          </nav>
          <div className={styles['controls']}>
            {call}
            {callback}
            {favorite}
          </div>
        </div>
      </div>
    </div>
  );
};

Header.displayName = 'Header';
